import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import LandingPage from "./LandingPage";
import jsDig from "utils/jsDig";
import { v4 as uuidv4 } from "uuid";

export default function LandingPages(props) {
  const [lpGroups, setLpGroups] = useState(jsDig(["seo_section", "landing_page_groups"], props) ? jsDig(["seo_section", "landing_page_groups"], props) : []);
  const lpGroupOrder = jsDig(["seo_section", "landing_page_group_order"], props) ? jsDig(["seo_section", "landing_page_group_order"], props) : [];
  const defaultSectionOrder = lpGroupOrder.length > 0 ? lpGroupOrder.map((id) => id.toString()) : [];
  const [sectionOrder, setSectionOrder] = useState(defaultSectionOrder);
  const originalGroupIds = (jsDig(["seo_section", "landing_page_groups"], props) ? jsDig(["seo_section", "landing_page_groups"], props) : []).map(
    (group) => group.id
  );
  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;
    if (!destination) {
      return;
    }
    if (destination.droppableId === source.droppableId && destination.index === source.index) {
      return;
    }

    let newOrder = [...sectionOrder];
    newOrder.splice(source.index, 1);
    newOrder.splice(destination.index, 0, draggableId);
    setSectionOrder(newOrder);
  };

  useEffect(() => {
    if (props.onboarding) {
      if (props.setLandingPageGroups) {
        let newGroups = sectionOrder.map((groupId) => {
          const group = lpGroups.find((group) => group.id == groupId);
          let newGroup = { name: group.name, conditions: group.conditions };
          if (originalGroupIds.includes(group.id)) {
            newGroup.id = group.id;
          }
          return newGroup;
        });

        props.setLandingPageGroups([...newGroups]);
      }
    }
  }, [lpGroups, sectionOrder]);

  return (
    <>
   
      {!props.onboarding &&
        sectionOrder.map((groupId) => {
          const group = lpGroups.find((group) => group.id == groupId);
          return (
            <React.Fragment key={group.id}>
              <input hidden readOnly name="[landing_page_groups][][name]" value={group.name} />
              {group.conditions &&
                group.conditions.map((condition, conditionIndex) => {
                  return (
                    <React.Fragment key={conditionIndex}>
                      <input hidden readOnly name="[landing_page_groups][][conditions][][type]" value={condition.type} />
                      <input hidden readOnly name="[landing_page_groups][][conditions][][url]" value={condition.url} />
                    </React.Fragment>
                  );
                })}
              {originalGroupIds.includes(group.id) && <input hidden readOnly name="[landing_page_groups][][id]" value={group.id} />}
            </React.Fragment>
          );
        })}
      <Container fluid className="top-div seo-config-tab-content px-md-3 pl-0 pr-1 mb-5 py-4" style={{ backgroundColor: props.onboarding ? "#F5F5F5" : "#EEEEEE" }}>
        <Row className=" pt-2 pl-md-0 pl-2 pr-4 pb-0 m-0">
          <Col className="">
            <h3 className="green visby-bold">Landing Page Tracking</h3>
          </Col>
        </Row>
        <Row>
          <Col className="center-from-right  pr-0">
            <Button
              style={{ marginRight: "32px" }}
              className="mt-3 mb-3 ml-3 py-1 mr-0 mr-md-5 btn-lg trim-margin-left trim-margin-right  landing-button "
              as="input"
              type="button"
              value="+ Add landing page item"
              variant="success"
              onClick={(e) => {
                let newGroup = { id: uuidv4(), name: "", conditions: [] };
                setLpGroups([...lpGroups, newGroup]);
                setSectionOrder([...sectionOrder, newGroup.id]);
              }}
            />
          </Col>
        </Row>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="landing-page-groups-droppable">
            {(provided) => (
              <div className="landing-page-groups ml-0 ml-lg-5 px-3 px-md-0" {...provided.droppableProps} ref={provided.innerRef}>
                {sectionOrder.map((lpGroupId, index) => {
                  if (lpGroups.find((group) => group.id == lpGroupId)) {
                    return (
                      <LandingPage
                        key={lpGroupId}
                        index={index}
                        lpGroupId={lpGroupId}
                        lpGroups={lpGroups}
                        setLpGroups={setLpGroups}
                        sectionOrder={sectionOrder}
                        setSectionOrder={setSectionOrder}
                      />
                    );
                  }
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </Container>
    </>
  );
}
